import DrawBase from "../DrawBase"
import EditSquare from "./EditSquare"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawSquare extends DrawBase {


    constructor(options) {
        super(options);
    }

    getTypeName() {
        return "正方形";
    }

    getType() {
        return "polygon_Nor";
    }

    getEditInterface() {
        return EditSquare;
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 1) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            return new $this.Cesium.PolygonHierarchy($this.square(positions));

        }, false);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var positions = JSON.parse(data.editPositions);
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            return new $this.Cesium.PolygonHierarchy($this.square(positions));

        }, true);

        var polygon = this.createPolygon(hierarchyProperty);
        entity.polygon = polygon;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "polygon")
    }

    //计算坐标点
    square(positions) {
        var $this = this;
        var length = positions.length;
        var p1 = positions[0];
        var p2 = positions[length - 1];
        var firstPoint = $this.cartesianToLatlng(p1);
        var endPoints = $this.cartesianToLatlng(p2);

        //var dis = this.distance(firstPoint, endPoints) / Math.sqrt(2);

        var dis = Cesium.Cartesian3.distance(p1, p2) / Math.sqrt(2);

        var a = $this.getPositionTranslation(p1, { x: - dis, y: - dis, z: 0 });
        var b = $this.getPositionTranslation(p1, { x: + dis, y: - dis, z: 0 });
        var c = $this.getPositionTranslation(p1, { x: + dis, y: + dis, z: 0 });
        var d = $this.getPositionTranslation(p1, { x: - dis, y: + dis, z: 0 });

        // var a = Cesium.Cartesian3.fromDegrees(firstPoint[0] - dis, firstPoint[1] - dis);
        // var b = Cesium.Cartesian3.fromDegrees(firstPoint[0] + dis, firstPoint[1] - dis);
        // var c = Cesium.Cartesian3.fromDegrees(firstPoint[0] + dis, firstPoint[1] + dis);
        // var d = Cesium.Cartesian3.fromDegrees(firstPoint[0] - dis, firstPoint[1] + dis);
        return [a, b, c, d, a];
    }

    distance(t, o) {
        return Math.sqrt(Math.pow(t[0] - o[0], 2) + Math.pow(t[1] - o[1], 2))
    }
}

export default DrawSquare